import React, { useState } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import styled from '@emotion/styled'
import { Box, Card, FormControl, MenuItem, Select, Typography } from '@mui/material'
import { useAdminMachineTime, useSingleMachine } from '../../hooks/dashboard'
import { useGetFullresourceMachine } from '../../hooks/resourceHooks'

const MainCard = styled(Card)(() => ({
  '.chart-title': {
    fontSize: 18,
    fontWeight: '600',
    padding: 7
    // padding: 18
  },
  '.parent-bar-chart': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 16px',
    background: '#F0F6FF',
    border: '1px solid #DEDEDE',
    // margin: "10px",
    width: '100%'
  },
  '.Overall': {
    fontSize: '16px',
    fontWeight: '600'
  },
  '.percentile': {
    fontSize: '18px',
    fontWeight: '700'
  }
}))

const MachineOverviewPieChart = (props) => {
  // Machine time data
  const {
    data: machineTimeData
    // isFetching: isMachineTime
  } = useAdminMachineTime()
  const adminMachineTime = machineTimeData?.data
  const [selectedResource, setSelectedResource] = useState('')

  const { data: singleData } = useSingleMachine(selectedResource, !!selectedResource)
  const rowsMachineTime = adminMachineTime?.map((data) => {
    return {
      id: data?._id,
      department: data?.department?.name ? data?.department?.name : '-',
      idleTime: data?.idleTime ? data?.idleTime : '-',
      machiningTime: data?.machiningTime ? data?.machiningTime : '-',
      name: data?.name ? data?.name : '-',
      setupTime: data?.setupTime ? data?.setupTime : '-',
      breakdownTime: data?.breakdownTime ? data?.breakdownTime : '-'
    }
  })

  const { data: resourcesData } = useGetFullresourceMachine()
  const resourcefullList = resourcesData?.data

  const resourceList = resourcefullList?.map((item) => {
    return {
      value: item?.id,
      label: item?.name
    }
  })

  const handleResourceChange = (event) => {
    setSelectedResource(event.target.value)
  }

  const filteredRowsMachineTime = selectedResource
    ? rowsMachineTime?.filter((row) => row.id === selectedResource)
    : rowsMachineTime

  const colorMap = {
    idleTime: '#800080', // Purple
    setupTime: '#FFA500', // Orange
    machiningTime: '#008000', // Green
    breakdownTime: '#FF0000' // Red
  }
  const chartData = [
    { name: 'Idle Time', key: 'idleTime', color: colorMap.idleTime },
    { name: 'Setup Time', key: 'setupTime', color: colorMap.setupTime },
    { name: 'Machining Time', key: 'machiningTime', color: colorMap.machiningTime },
    { name: 'Breakdown Time', key: 'breakdownTime', color: colorMap.breakdownTime }
  ].map((item) => {
    const total = filteredRowsMachineTime?.reduce(
      (sum, row) => sum + (parseFloat(row[item.key]) || 0),
      0
    )

    return {
      name: item.name,
      y: total,
      color: item.color
    }
  })
  const singleChartData = [
    { name: 'Idle Time', key: 'idleTime', color: colorMap.idleTime },
    { name: 'Setup Time', key: 'setupTime', color: colorMap.setupTime },
    { name: 'Machining Time', key: 'machiningTime', color: colorMap.machiningTime },
    { name: 'Breakdown Time', key: 'breakdownTime', color: colorMap.breakdownTime }
  ].map((item) => {
    const total = singleData?.data?.reduce(
      (sum, row) => sum + (parseFloat(row[item.key]) || 0),
      0
    )

    return {
      name: item.name,
      y: total,
      color: item.color
    }
  })

  const {
    title,
    // type = 'column',
    // data,
    // isGridLine = false,
    height,
    barChartData = true
  } = props
  const options = {
    chart: {
      type: 'pie',
      height
    },
    title: {
      text: null
    },
    credits: { enabled: false },
    exporting: {
      enabled: false // This disables the three dots menu
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
          // format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        showInLegend: true // Show legend outside the chart
      }
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      symbolRadius: 0, // Makes the legend symbols square
      itemStyle: {
        fontSize: '12px',
        fontWeight: '500'
      }
    },
    // series: [
    //   {
    //     name: 'Time',
    //     colorByPoint: true,
    //     data: [
    //       {
    //         name: 'Idle Time',
    //         y: 5,
    //         // y: 5,
    //         color: '#800080'
    //       }, // Purple
    //       {
    //         name: 'Setup Time',
    //         y: 5,
    //         color: '#FFA500'
    //       }, // Orange
    //       {
    //         name: 'Machining Time',
    //         y: 10,
    //         color: '#008000'
    //       }, // Green
    //       {
    //         name: 'Breakdown Time',
    //         y: 15,
    //         color: '#FF0000'
    //       } // Red
    //     ]
    //   }
    // ]
    series: [
      {
        name: 'Time',
        colorByPoint: true,
        data: selectedResource ? singleChartData : chartData
      }
    ]
  }

  return (
    <div className="App">
      <MainCard
        variant="standerd"
        sx={{
          border: '1px solid #E6EAEF',
          padding: '15px 15px 0px 15px',
          borderRadius: '0px'
        }}
      >
        {/* {type === 'bar' && (
          <Box className="parent-bar-chart">
            <Typography className="Overall">Overall Utilization</Typography>
            <Typography className="percentile">-</Typography>
          </Box>
        )} */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '5px'
          }}
        >
          <Typography className="chart-title">{title}</Typography>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>

            <Select
              placeholder='Machine'
              displayEmpty
              labelId="chart-dropdown-label"
              value={selectedResource}
              onChange={handleResourceChange}
            >
                <MenuItem value="" disabled>
                  Machines
                </MenuItem>
             {resourceList?.map((data, ind) => {
               return (
              <MenuItem color="black" value={data?.value} key={ind}>
                {data?.label}
              </MenuItem>
               )
             })}
            </Select>
          </FormControl>
        </Box>

        <Box
          className={`${
            barChartData
              ? 'bar-chart-padding-dash'
              : 'column-chart-padding-dash'
          }`}
        >
         { <HighchartsReact highcharts={Highcharts} options={options} />}
        </Box>
      </MainCard>
    </div>
  )
}

export default MachineOverviewPieChart
